import React from "react";
import email from "../../assets/images/contact/email.png";
import call from "../../assets/images/contact/call.png";
import follow from "../../assets/images/contact/follow.png";
import location from "../../assets/images/contact/location.png";


export const ContactForm = () => {
  return (
    <div className="contactForm">
      <div className="container">
        <div className="contactGrid">
          <div className="contactLeft">
            <div className="contactLeftTitle">Get in Touch with SnapBid</div>
            <div className="contactLeftDesc">
              Have questions, suggestions, or need support? We’re here to help
              you every step of the way.
            </div>
            <div className="contactCardGrid">
                <div className="contactCard">
                    <div><img src={email}/></div>
                    <div>Email Us On</div>
                    <div>snapbid@gmail.com</div>

                </div>
                <div className="contactCard">
                    <div><img src={call}/></div>
                    <div>Call Us On</div>
                    <div>+91 96857 41425</div>

                </div>
                <div className="contactCard">
                    <div><img src={location}/></div>
                    <div>Visit our Offline</div>
                    <div>1/23, Road no 2, Banjara Hills, Hyderabad</div>

                </div>
                <div className="contactCard">
                    <div><img src={follow}/></div>
                    <div>Follow Us On</div>
                    <div className="d-flex text-center justify-content-center ">
                        <span className="me-2">Instagram</span>
                        <span className="me-2">Facebook</span>
                        <span className="me-2">LinkedIn</span>
                        <span>Twitter</span>
                    </div>

                </div>


            </div>
          </div>
          <div className="contactRight">
           <form>
            <div className="contactFormTitle">Contact Form</div>
            <div className="contactInput">
                <label>Full Name <span className="text-danger">*</span></label>
                <div><input type="text" placeholder="eg: andrew"/></div>

            </div>
              <div className="contactInput">
                <label>Email<span className="text-danger">*</span></label>
                <div><input type="email" placeholder="eg: andrew123@gmail.com"/></div>

            </div>
              <div className="contactInput">
                <label>Mobile Number<span className="text-danger">*</span></label>
                <div><input type="text" placeholder="eg: 8523697410"/></div>

            </div>
            <div className="contactInput">
                <label>Message<span className="text-danger">*</span></label>
                <div><textarea rows={4} placeholder="Type Here"></textarea></div>

            </div>
            <div className="btnSubmit"><button>Submit</button></div>

           </form>
          </div>
        </div>
      </div>
    </div>
  );
};
